import {IHttpClientResponse} from 'core/types';

export abstract class AbstractApiResponseInterceptor {
    public abstract intercept(response: IHttpClientResponse, requestParam?: RequestInit): Promise<IHttpClientResponse>;
}
